import { Component, ElementRef, ViewChild,NgZone, QueryList, ViewChildren } from '@angular/core';
import { ComputerCentreService } from '../../../services/cc/computer-centre.service';
import { InternetSpeedTestListModel } from '../../../models/cc/computer-centre-models';
import { Chart } from 'chart.js/auto';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-internet-speeds-check',
  imports: [CommonModule],
  templateUrl: './internet-speeds-check.component.html',
  styleUrl: './internet-speeds-check.component.css'
})
export class InternetSpeedsCheckComponent {

// @ViewChild('ispeedCanvas')
// set canvasSetter(el: ElementRef<HTMLCanvasElement>) {
//   if (el) {
//     this.ispeedCanvas = el;
//     console.log('✅ Canvas created');
//     this.renderCgpaChartIfReady();
//   }
// }

// @ViewChild('ispeedCanvas') ispeedCanvas!: ElementRef<HTMLCanvasElement>;

@ViewChildren('ispeedCanvas') canvases!: QueryList<ElementRef<HTMLCanvasElement>>;
@ViewChildren('ispeedCanvas') ispeedCanvas!: QueryList<ElementRef>;

internetSpeedChart? : Chart;
// ispeedCanvas!: ElementRef<HTMLCanvasElement>;
// private viewReady = false;
// private dataLoaded = false;


filterDataLabels: any[] = [{id:1, duration:'Day'},{id: 2, duration:'Week'},{id:3, duration: 'Month'},{id: 4,duration: 'Year'}];

internetSpeeds: InternetSpeedTestListModel[] = [];
allInternetSpeeds: InternetSpeedTestListModel[] = [];
providerDataMap: { [key: string]: InternetSpeedTestListModel[] } = {};
providerFilteredDataMap: { [key: string]: InternetSpeedTestListModel[] } = {};

chartsMap: { [key: string]: any } = {};



getProviderLabel(ip: string): string{
  switch(ip){
    case '172.16.0.1': return 'BSNL'
    case '172.16.0.2': return 'Poineer'
    case '172.16.0.3': return 'ActFiber Broadband'
    case '172.16.0.5': return 'ActFiber Leasedline'
    default: return ip
  } 
}

providerKeys: string[] = [];
charts: Chart[] = [];

constructor(private ccSerive: ComputerCentreService,
  private zone: NgZone
){}

ngOnInit() {
  this.loadInternetSpeeds();
}

// loadInternetSpeeds(){
//   this.ccSerive.GetInternetSpeedsCheck().subscribe({
//     next: (data)=>{
//       console.log("internet speeds are:",data);
//       this.internetSpeeds = data;
//       this.allInternetSpeeds = data;
//       // this.dataLoaded = true;
//       const groupedData = this.prepareChartData();
//       this.providerKeys = Object.keys(groupedData);
//       // this.createChart();

//       // this.tryCreateChart();

//       setTimeout(()=>{
//         this.createCharts();
//       })
//     },
//     error: (err)=> {
//       console.error("error fetching the data:",err);
//     }
//   })
// }

// private renderCgpaChartIfReady() {
//   if (!this.viewReady) return;
//   if (!this.ispeedCanvas) return;
//   if (!this.internetSpeeds.length) return;

//   if (this.cgpaChart) {
//     this.cgpaChart.destroy();
//     this.cgpaChart = undefined;
//   }

//   requestAnimationFrame(()=>{
//     this.createChart();
//   });

// }

loadInternetSpeeds() {
  this.ccSerive.GetInternetSpeedsCheck().subscribe({
    next: (data) => {

      this.allInternetSpeeds = data;

      // 🔥 Group data by provider
      data.forEach(item => {

        const provider = item.providerIp; // or use getProviderLabel()

        if (!this.providerDataMap[provider]) {
          this.providerDataMap[provider] = [];
        }

        this.providerDataMap[provider].push(item);
      });

      // Initially filtered = original
      this.providerFilteredDataMap = { ...this.providerDataMap };

      this.providerKeys = Object.keys(this.providerDataMap);

      setTimeout(() => this.createCharts());
    }
  });
}


ngOnDestroy(){
  if(this.internetSpeedChart){
    this.internetSpeedChart.destroy();
    this.internetSpeedChart = undefined;
  }
}


prepareChartData(){
  const groupedData: any = {}

  this.internetSpeeds.forEach((item: InternetSpeedTestListModel)=>{
    const label = this.getProviderLabel(item.providerIp)

    if(!groupedData[label]){
      groupedData[label] = {
        download: [],
        upload: [],
        labels: []
      }
    }

    groupedData[label].labels.push(new Date(item.dateAndTime).toLocaleTimeString());
    groupedData[label].download.push(+item.downloadSpeed);
    groupedData[label].upload.push(+item.uploadSpeed);
  });
  return groupedData;
}

// createChart(){
//   if (!this.ispeedCanvas) return;
//   if (!this.internetSpeeds || this.internetSpeeds.length === 0) return;
//    if (this.internetSpeedChart) {
//     this.internetSpeedChart.destroy();
//     this.internetSpeedChart = undefined;
//   }
//   const canvas = this.ispeedCanvas.nativeElement;
//     canvas.width = canvas.parentElement!.clientWidth;
//     canvas.height = 300;
//     const speedchart = canvas.getContext('2d');
//     if (!speedchart) return;

//   const groupedData = this.prepareChartData();

//   const datasets: any = []

//   Object.keys(groupedData).forEach(provider=>{
//     datasets.push({
//       label: provider + ' Download',
//       data: groupedData[provider].download,
//       borderWidth: 2,
//       fill: false
//     })
//   })

//   Object.keys(groupedData).forEach(provider=>{
//     datasets.push({
//       label: provider + ' upload',
//       data: groupedData[provider].upload,
//       borderDash: [5,5],
//       fill: false
//     });
//   });

//   const firstKey = Object.keys(groupedData)[0];
//   if (!firstKey) return

//   this.zone.runOutsideAngular(()=>{
//     this.internetSpeedChart =  new Chart(speedchart,{
//       type: 'line',
//       data: {
//         labels: groupedData[Object.keys(groupedData)[0]].labels,
//         datasets: datasets
//       },
//       options: {
//         responsive: true,
//         plugins: {
//           legend: {
//             position: 'top'
//           }
//         },
//         scales: {
//           y: {
//             beginAtZero: true,
//             title: {
//               display: true,
//               text: 'Speed (mbps)'
//             }
//           }
//         }
//       }
//     });
//   })


// }

// createCharts() {

//   // Destroy old charts
//   this.charts.forEach(chart => chart.destroy());
//   this.charts = [];

//   const groupedData = this.prepareChartData();
//   // this.providerKeys = Object.keys(groupedData);

//   // setTimeout(()=>{
//   //   this.createCharts();
//   // })

//   this.zone.runOutsideAngular(() => {

//     this.canvases.forEach((canvasRef, index) => {

//       const provider = this.providerKeys[index];
//       if (!provider) return;

//       const ctx = canvasRef.nativeElement.getContext('2d');
//       if (!ctx) return;

//       const chart = new Chart(ctx, {
//         type: 'line',
//         data: {
//           labels: groupedData[provider].labels,
//           datasets: [
//             {
//               label: 'Download',
//               data: groupedData[provider].download,
//               borderWidth: 2,
//               fill: false
//             },
//             {
//               label: 'Upload',
//               data: groupedData[provider].upload,
//               borderDash: [5, 5],
//               fill: false
//             }
//           ]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           animation: false,
//           plugins: {
//             legend: { position: 'top' }
//           },
//           scales: {
//             y: {
//               beginAtZero: true,
//               title: {
//                 display: true,
//                 text: 'Speed (mbps)'
//               }
//             }
//           }
//         }
//       });

//       this.charts.push(chart);

//     });

//   });
// }

createCharts() {
  this.zone.runOutsideAngular(()=>{
    this.providerKeys.forEach((provider, index) => {
  
      const canvas = this.ispeedCanvas.toArray()[index].nativeElement;
  
      const data = this.providerFilteredDataMap[provider];
  
      const chart = new Chart(canvas, {
        type: 'line',
        data: {
          labels: data.map(d =>
            new Date(d.dateAndTime).toLocaleTimeString()
          ),
          datasets: [
            {
              label: 'Download',
              data: data.map(d => +d.downloadSpeed),
              borderWidth: 2
            },
            {
              label: 'Upload',
              data: data.map(d => +d.uploadSpeed),
              borderWidth: 2
            }
          ]
        }
      });
  
      // 🔥 Store chart by provider name
      this.chartsMap[provider] = chart;
    });
  })
}



// dataFilterBySelection(durationId: number){
//   console.log("selected: ",durationId);
//   this.filterDataByDuration(durationId)

// }

dataFilterBySelection(provider: string, durationId: number) {
  this.filterDataByDuration(provider, durationId);
}





// filterDataByDuration(did: number){
//   if(this.internetSpeedChart){
//     this.internetSpeedChart.destroy();
//     this.internetSpeedChart = undefined
//   }
// const today = new Date().toISOString().split('T')[0]
// if(did === 1){
//   console.log("before filtering the data",this.internetSpeeds);
//   this.internetSpeeds = this.allInternetSpeeds.filter(speed => 
//     speed.dateAndTime.startsWith(today)
//   )
// }
// else if (did === 2){

//   }
// console.log("data after selecting filter:",this.internetSpeeds, today);
//   // this.prepareChartData();
//   this.createChart();
  
// }

ngAfterViewInit() {
  // this.viewReady = true;
  // this.renderCgpaChartIfReady();

  // this.tryCreateChart();
}

// private tryCreateChart() {
//   if (!this.dataLoaded) return;
//   // if (!this.ispeedCanvas) return;

//   if (!this.canvases || this.canvases.length === 0) return;

//   // this.createChart();

//   this.createCharts();
// }



// filterDataByDuration(did: number){

//   const now = new Date();

//   // Reset to original data first
//   this.internetSpeeds = [...this.allInternetSpeeds];

//   if(did === 1){
//     // ✅ TODAY (from 00:00)
//     const startOfDay = new Date(
//       now.getFullYear(),
//       now.getMonth(),
//       now.getDate(),
//       0, 0, 0
//     );

//     this.internetSpeeds = this.allInternetSpeeds.filter(speed =>
//       new Date(speed.dateAndTime) >= startOfDay
//     );
//   }

//   else if(did === 2){
//     // ✅ WEEK (Last 7 Days)
//     const sevenDaysAgo = new Date();
//     sevenDaysAgo.setDate(now.getDate() - 7);

//     this.internetSpeeds = this.allInternetSpeeds.filter(speed =>
//       new Date(speed.dateAndTime) >= sevenDaysAgo
//     );
//   }

//   else if(did === 3){
//     // ✅ MONTH (Current Month)
//     const startOfMonth = new Date(
//       now.getFullYear(),
//       now.getMonth(),
//       1
//     );

//     this.internetSpeeds = this.allInternetSpeeds.filter(speed =>
//       new Date(speed.dateAndTime) >= startOfMonth
//     );
//   }

//   else if(did === 4){
//     // ✅ YEAR (Current Year)
//     const startOfYear = new Date(
//       now.getFullYear(),
//       0,
//       1
//     );

//     this.internetSpeeds = this.allInternetSpeeds.filter(speed =>
//       new Date(speed.dateAndTime) >= startOfYear
//     );
//   }

//   // this.createChart();

//   this.createCharts();
// }

filterDataByDuration(provider: string, did: number) {

  const now = new Date();

  const originalData = this.providerDataMap[provider];
  let filtered = [...originalData];

  if (did === 1) {
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    filtered = originalData.filter(speed =>
      new Date(speed.dateAndTime) >= startOfDay
    );
  }

  else if (did === 2) {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(now.getDate() - 7);

    filtered = originalData.filter(speed =>
      new Date(speed.dateAndTime) >= sevenDaysAgo
    );
  }

  else if (did === 3) {
    const startOfMonth = new Date(
      now.getFullYear(),
      now.getMonth(),
      1
    );

    filtered = originalData.filter(speed =>
      new Date(speed.dateAndTime) >= startOfMonth
    );
  }

  else if (did === 4) {
    const startOfYear = new Date(
      now.getFullYear(),
      0,
      1
    );

    filtered = originalData.filter(speed =>
      new Date(speed.dateAndTime) >= startOfYear
    );
  }

  this.providerFilteredDataMap[provider] = filtered;

  this.updateSingleChart(provider);
}

updateSingleChart(provider: string) {

  const chart = this.chartsMap[provider];

  if (!chart) return;

  const data = this.providerFilteredDataMap[provider];

  chart.data.labels = data.map(d =>
    new Date(d.dateAndTime).toLocaleTimeString()
  );

  chart.data.datasets[0].data = data.map(d => +d.downloadSpeed);
  chart.data.datasets[1].data = data.map(d => +d.uploadSpeed);

  chart.update();
}


}
